let opts = [
    'price',
    'price-pre',
    'price-post',
    'currency-symbol',
    'dollars',
    'cents',
    'units',
    'note',
    'sds-product-card',
    'sds-input',
    'sds-select',
    'sds-button',
    'sds-icon',
    'sds-badge',
    'sds-ratings',
    'sds-product-variants',
];

module.exports = function() {
    return opts;
};
